module.exports = __webpack_public_path__ + "a02503edd0542cdd63012c63aad03d37.png";